// ReconciliationBallSection

import Container from "../../../components/ui/Container";

export default function ReconciliationBallSection() {
  return (
    <section className="event-noise bg-twilight-indigo-950 px-0 py-20 text-white md:py-28">
      <Container>
        <div className="mx-auto max-w-4xl text-center">
          <div className="mx-auto mb-16 h-20 w-px bg-amber-flame-500/70" />

          <p className="mx-auto font-serif text-xl italic leading-relaxed text-slate-100 md:max-w-[560px] md:text-2xl">
            The Reconciliation Ball will begin at 5:00 PM and conclude at 9:00 PM.
          </p>

          <div className="mt-16">
            <p className="mb-5 text-xs font-semibold uppercase tracking-[0.5em] text-amber-flame-500">
              Venue
            </p>

            <h2 className="font-display text-2xl font-bold leading-tight text-white md:text-5xl">
              UL Auditorium,
              <br />
              Capitol Hill Campus
            </h2>
          </div>

          <div className="mx-auto mt-16 h-20 w-px bg-amber-flame-500/70" />
        </div>
      </Container>
    </section>
  );
}